import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=4ddfc3ad&scoped=true&"
import script from "./Transaction.vue?vue&type=script&lang=js&"
export * from "./Transaction.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&id=4ddfc3ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddfc3ad",
  null
  
)

export default component.exports